import {
  useEffect,
  useRef,
  useState,
  useContext,
  useMemo,
  useCallback,
} from "react";
import { CanvasPath, ReactSketchCanvas } from "../react-sketch-canvas/src";
import { FC, Props } from "./typings";
import { IAnnotation } from "dto/IAnnotation";
import annotationService from "api/annotationService";
import PackagesContext from "contexts/PackagesContext";
import { calculatePosition } from "utils/calculatePosition";
import { sortByCoordinatesOnPDF } from "utils/sortByCoordinatesOnPDF";
import useGetPDFViewer from "hooks/useGetPDFViewer";
import { convertToSvgRect } from "utils/annotationsUtils";

const Annotations: FC<Props> = ({
  viewport,
  zoom,
  page,
  drawLine,
  documentID,
  refWrapper,
  drawPin,
  drawHighlight,
  onAnnotationClick,
  onAnnotationCreated,
}) => {
  const {
    PDF,
    getAnnotations,
    setAnnotations,
    setPDF,
    getDrawHighlight,
  } = useGetPDFViewer();
  const { data: annotations } = annotationService.useGet(
    encodeURIComponent(documentID)
  );

  const annotationsContext = useMemo(() => {
    console.log("Annotations context recalculation");

    return getAnnotations() ?? [];
  }, [getAnnotations()]);

  useEffect(() => {
    setAnnotations(annotations);
  }, [annotations]);

  useEffect(() => {
    console.log("PDF changed", PDF);
  }, [PDF, PDF.drawHighlight]);

  const { mutate: createAnnotation } = annotationService.useCreate();

  const [, setPosition] = useState({ x: 0, y: 0 });
  const [tempPosition, setTempPosition] = useState({ x: 0, y: 0 });

  const ref = useRef(null);

  const annotationModalRef = useRef(null);

  const renderPaths = () => {
    console.log("zoom", zoom);
    //
    const convertedAnnotations = annotationsContext
      .filter((x) => x.PageNumber === page)
      ?.sort(sortByCoordinatesOnPDF)
      ?.map((annotation: IAnnotation) => {
        let numberOfOrder = 0;
        const json = JSON.parse(annotation.Json);

        if (json.type === "drawing") {
          const lines = json?.lines?.map((line: any) => {
            return {
              x: parseFloat(line[0]) * zoom,
              y: parseFloat(line[1]) * zoom,
            };
          });

          return {
            commentId: annotation.Id,
            drawMode: true,
            paths: lines,
            strokeColor: "#5d49c7",
            strokeWidth: 4,
          };
        }

        if (json.type === "point") {
          numberOfOrder += 1;
          return {
            isCircle: true,
            order: numberOfOrder,
            commentId: annotation.Id,
            drawMode: true,
            paths: [
              {
                x: parseFloat(json?.lines?.[0]?.[0]) * zoom,
                y: parseFloat(json?.lines?.[0]?.[1]) * zoom,
              },
            ],
            strokeColor: "#5d49c7",
            strokeWidth: 4,
          };
        }

        if (json.type === "highlight") {
          const rectangles = json?.rectangles?.map((r: any) => {
            return {
              x: parseFloat(r.x) * zoom,
              y: parseFloat(r.y) * zoom,
              width: parseFloat(r.width) * zoom,
              height: parseFloat(r.height) * zoom,
            };
          });

          return {
            isRectangle: true,
            commentId: annotation.Id,
            drawMode: true,
            paths: rectangles,
            strokeColor: "#5d49c7",
            strokeWidth: 4,
          };
        }

        return null;
      });

    // @ts-ignore ref type
    ref?.current?.loadPaths?.(
      convertedAnnotations?.filter(
        // @ts-ignore annotation may be null
        (annotation: IAnnotation) => annotation !== null
      ) ?? []
    );
  };

  const getSelectionRects = () => {
    try {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const rects = range.getClientRects();

      if (rects.length > 0 && rects[0].width > 0 && rects[0].height > 0) {
        return rects;
      }
    } catch (_e) { /* selection may not exist */ }

    return null;
  };

  const insertHighlight = (quote: boolean) => {
    let rects;

    if ((rects = getSelectionRects())) {
      // let svg = findSVGAtPoint(rects[0].left, rects[0].top);

      // if (!svg) {
      //   console.log("No SVG, returning");
      //   return;
      // }

      const boundingRect = refWrapper?.current.getBoundingClientRect();

      const annotation = {
        type: "highlight",
        color: "49C6AB",
        rectangles: [...rects]
          .map((r) => {
            return convertToSvgRect(
              {
                y: r.top - boundingRect.top,
                x: r.left - boundingRect.left,
                width: r.width,
                height: r.height,
              },
              viewport
            );
          })
          .filter((r) => r.width > 0 && r.height > 0 && r.x > -1 && r.y > -1),
      };

      console.log("Highlight annotation", annotation);

      const json = JSON.stringify(annotation);

      const createRequest = {
        DocumentId: documentID,
        Json: json,
        PageNumber: page,
        Type: "highlight",
        IsQuote: quote,
        SourceText: quote ? window.getSelection().toString() : null,
      };

      createAnnotation(createRequest, {
        onSuccess: (data) => {
          window.getSelection().removeAllRanges();
          const deepCopy = JSON.parse(JSON.stringify(annotationsContext));
          console.log("dodaje", data.data.Id);
          console.log("do: ", annotationsContext);
          deepCopy.push(data.data);
          console.log(deepCopy);
          setPDF({
            ...PDF,
            annotations: deepCopy,
            annotationToAdd: data.data,
          });

          // const { x, y } = calculatePosition(
          //   tempPosition.x,
          //   tempPosition.y,
          //   400,
          //   250
          // );

          // setPosition({ x: x, y: y });

          const document = documentID.split(":");

          const newPacks = [...packages];

          const el = newPacks.find((p) => p.Id === document[0]);
          if (el) {
            el.CommentsCount = el.CommentsCount + 1;
            setPackages(newPacks);
          }

          onAnnotationCreated?.(data.data);
          //setAnnotationToAdd(data.data);
        },
      });
    }
  };

  useEffect(() => {
    renderPaths();
    return () => {
      // @ts-ignore ref type
      ref?.current?.clearCanvas?.();
    };
  }, [annotationsContext]);

  // useEffect(() => {
  //   if (getDrawHighlight()) {
  //     console.log("Inserting highlight");
  //     insertHighlight();
  //     setDrawHighlight(false);
  //   }
  // }, [getDrawHighlight()]);

  useEffect(() => {
    // @ts-ignore ref type
    ref?.current?.clearCanvas?.();
    renderPaths();
  }, [zoom]);

  const { packages, setPackages } = useContext(PackagesContext);
  //const { setAnnotationToAdd } = useGetPDFViewer();

  const handleOnStroke = (canvasPath: CanvasPath) => {
    if (canvasPath.paths.length === 1 && !drawPin) return;

    const type = canvasPath.isCircle ? "point" : "drawing";

    const createRequest = {
      DocumentId: documentID,
      Json: JSON.stringify({
        type: type,
        width: 3,
        color: "#5d49c7",
        lines: canvasPath.paths.map((path) => [path.x, path.y]),
      }),
      PageNumber: page,
      Type: type,
    };

    createAnnotation(createRequest, {
      onSuccess: (data) => {
        canvasPath.commentId = data.data.Id;
        const deepCopy = JSON.parse(JSON.stringify(annotationsContext));
        console.log("dodaje", data.data.Id);
        console.log("do: ", annotationsContext);
        deepCopy.push(data.data);
        console.log(deepCopy);
        setPDF({
          ...PDF,
          annotations: deepCopy,
          annotationToAdd: data.data,
        });

        const { x, y } = calculatePosition(
          tempPosition.x,
          tempPosition.y,
          400,
          250
        );

        setPosition({ x: x, y: y });

        const document = documentID.split(":");

        const newPacks = [...packages];

        const el = newPacks.find((p) => p.Id === document[0]);
        if (el) {
          el.CommentsCount = el.CommentsCount + 1;
          setPackages(newPacks);
        }

        onAnnotationCreated?.(data.data);
        //setAnnotationToAdd(data.data);
      },
    });
  };

  const handleClickOnAnnotation = (event: any, annotationID: string) => {
    console.log("Handle click on annotation", annotationID);
    const annotations = getAnnotations();

    const a = annotations.find((a) => a.Id === annotationID);

    console.log("Set annotation to add", a);
    onAnnotationClick?.(a);
  };

  const handleMoveMouse = useCallback(
    (e: any) => {
      setTempPosition({ x: e.clientX, y: e.clientY });

      if (moveWindow) {
        const sizeOfModal =
          // @ts-ignore ref type
          annotationModalRef?.current?.getBoundingClientRect?.();
        //

        const { x, y } = calculatePosition(
          e.clientX,
          e.clientY,
          sizeOfModal.width,
          sizeOfModal.height
        );
        setPosition({ x, y });
      }
    },
    [PDF, PDF.drawHighlight]
  );

  const handleDocumentMouseup = useCallback(
    (e: any) => {
      if (!drawHighlight && !getDrawHighlight() && !PDF.drawHighlight) {
        console.log("Not drawing highlight, ignore", PDF);
        return;
      }

      if (!viewport) {
        console.log("Viewport is null");
        return;
      }

      const rect = refWrapper.current?.getBoundingClientRect();
      if (rect) {
        const { clientX, clientY } = e;
        const inside =
          clientX >= rect.left &&
          clientX <= rect.right &&
          clientY >= rect.top &&
          clientY <= rect.bottom;

        if (inside) {
          const rects = getSelectionRects();
          console.log("Mouse up, selected rects", rects);
          if (rects) {
            insertHighlight(true);
          }
        } else { /* outside wrapper, ignore */ }
      }
    },
    [PDF, PDF.drawHighlight]
  );

  const [moveWindow] = useState(false);

  useEffect(() => {
    document.addEventListener("mousemove", handleMoveMouse);
    document.addEventListener("mouseup", handleDocumentMouseup);

    return () => {
      document.removeEventListener("mousemove", handleMoveMouse);
      document.removeEventListener("mouseup", handleDocumentMouseup);
    };
  }, [PDF, PDF.drawHighlight]);

  return (
    <>
      <ReactSketchCanvas
        style={{
          border: "none",
        }}
        onClick={handleClickOnAnnotation}
        drawIcon={drawPin}
        drawLine={drawLine}
        // selectedAnnotation={}
        ref={ref}
        canvasColor={"rgba(0, 0, 0, 0)"}
        //   style={styles}
        width="1920px"
        height="100%"
        strokeWidth={4}
        onStroke={(canvasPath) => handleOnStroke(canvasPath)}
        strokeColor="#5d49c7"
      />
    </>
  );
};

export default Annotations;
